import React from "react";
import {
  InputProductLicense,
  InputProductName,
  InputProductPrice,
  InputProductEyebrow,
  InputProductFooter,
  InputProductNumber,
  InputProductIndex,
  InputProductSku,
} from "./components";
import "./index.scss";

/**
 * @desc Product Row Details.
 */
export const ProductRowDetails = ({ product }) => {
  return (
    <div className="product-row-details">
      <div className="row">
        <InputProductEyebrow product={product} />
        <InputProductLicense product={product} />
      </div>
      <InputProductName product={product} />
      <div className="row">
        <div className="row number-index">
          <InputProductNumber product={product} />
          <InputProductIndex product={product} />
        </div>
        <InputProductPrice product={product} />
      </div>
      <div className="row">
        <InputProductFooter product={product} />
        <InputProductSku product={product} />
      </div>
    </div>
  );
};
